import EmprestimoGarantiaCarroApp from '../components/templates/EmprestimoGarantiaCarroApp';

export default function EmprestimoGarantiaCarroAppPage() {
  return <EmprestimoGarantiaCarroApp />;
}

export async function getStaticProps() {
  return {
    props: {},
  };
}
